var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkAreaHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_4008",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.538086,
    y: 0.676758,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_4008)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53809 11.6768C4.98809 11.6768 4.51709 11.4808 4.12509 11.0888C3.73375 10.6974 3.53809 10.2268 3.53809 9.67676V5.67676C3.53809 5.12676 3.73375 4.65576 4.12509 4.26376C4.51709 3.87242 4.98809 3.67676 5.53809 3.67676H19.5381C20.0881 3.67676 20.5591 3.87242 20.9511 4.26376C21.3424 4.65576 21.5381 5.12676 21.5381 5.67676V9.67676C21.5381 10.2268 21.3424 10.6974 20.9511 11.0888C20.5591 11.4808 20.0881 11.6768 19.5381 11.6768H5.53809ZM5.53809 9.67676H19.5381V5.67676H5.53809V9.67676ZM5.53809 21.6768C4.98809 21.6768 4.51709 21.4811 4.12509 21.0898C3.73375 20.6978 3.53809 20.2268 3.53809 19.6768V15.6768C3.53809 15.1268 3.73375 14.6558 4.12509 14.2638C4.51709 13.8724 4.98809 13.6768 5.53809 13.6768H19.5381C20.0881 13.6768 20.5591 13.8724 20.9511 14.2638C21.3424 14.6558 21.5381 15.1268 21.5381 15.6768V19.6768C21.5381 20.2268 21.3424 20.6978 20.9511 21.0898C20.5591 21.4811 20.0881 21.6768 19.5381 21.6768H5.53809ZM5.53809 19.6768H19.5381V15.6768H5.53809V19.6768Z",
    fill: "#ADB5BD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkAreaHorizontal);
export default __webpack_public_path__ + "static/media/bookmark_area_horizontal.e37783b81904df47c11946d7f1f626b7.svg";
export { ForwardRef as ReactComponent };